export default "__VITE_ASSET__Dt3N6n5h__"